import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=2ea68939&scoped=true&"
import script from "./Columns.vue?vue&type=script&lang=ts&"
export * from "./Columns.vue?vue&type=script&lang=ts&"
import style0 from "./Columns.vue?vue&type=style&index=0&id=2ea68939&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea68939",
  null
  
)

export default component.exports